import {FlowableFormField, FormState} from "../types/FlowableFormTypes";
import React, {useEffect, useState} from "react";
import { InputLabel, TextField} from "@material-ui/core";
import {fieldValidationError} from "../forms/ISARequest";
import { getMaxCharacters } from "../forms/FormUtils";
import { AccountInfo } from "../types/UserInfoTypes";
import axios from "axios";
import config from "../config";



export function ReasonComponent(props:{field: FlowableFormField, formState: FormState, setFormState: (fs:FormState)=>void, addToFormState: (fs:FormState, key:string, value:unknown )=>FormState }) : JSX.Element {
    const [newReason] = useState<string|null>(null)
    const [oldReason, setOldReason] = useState<string|null>(null);
    const [accountInfo, setAccountInfo] = useState<AccountInfo>();
    const currentTime = new Date().toUTCString();

    const handleReasonTextChange = (e:React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => props.setFormState(props.addToFormState(props.formState, props.field.id, oldReason + (oldReason ? ' \n\n' : '') + currentTime + " by " + accountInfo?.fullName + ": \n" + e.target.value))
    const maxCharacters = getMaxCharacters(props.field.params?.validationExpression);

    

    useEffect(()=>{   
        getAccountInfoDisplayName();
        setOldReason(props.formState[props.field.id] ? props.formState[props.field.id] as string : "");
    }, [])

    async function getAccountInfoDisplayName(){
        const account = await axios.get(`${config.flowableUiApiBaseUrl}idm-app/rest/account`, {withCredentials:true})
      
        if(!account.data.id){
          return null
        }
        return setAccountInfo(account.data as AccountInfo);
    }
      

    function getMaxCharacterCalculation(field: FlowableFormField, maxCharacters: number, formState: FormState) {
        return <div style={{float:'right'}}>{(maxCharacters > 0) ? 'max '+ maxCharacters + ' characters (' + ((formState[field.id] as string | undefined || "").length + " / " + maxCharacters) + ')' : <></> }</div>
    
    }
    return <div>
                        <div className={'fieldDiv'}>
                            {oldReason ? <TextField  multiline 
                                       style={{width:"100%"}} variant="outlined" rows={3}
                                       value={oldReason as string | number | readonly string[] | undefined}
                                       disabled={true}
                            /> : <></> }
                        </div>
                    <div className={'fieldDiv'}>
                    <InputLabel error={fieldValidationError(props.field, props.formState).length > 0}>
                            {props.field.name}{props.field.required ? '*' : ''}
                        </InputLabel>
                        <TextField 
                                    onChange={(e) => handleReasonTextChange(e)}
                                    multiline error={fieldValidationError(props.field, props.formState).length > 0}
                                   style={{width:"100%"}} variant="outlined" rows={3}
                                   value={newReason as string | number | readonly string[] | undefined}
                                   disabled={props.field.readOnly}
                                   helperText={fieldValidationError(props.field, props.formState)}
                        />
                        {getMaxCharacterCalculation(props.field, maxCharacters, props.formState)}
                    </div>
                    </div> ;
}